var exports = {
  "h_": "DuplicateGroupConfirmModal.module__description___UWRUMW",
  "o5": "DuplicateGroupConfirmModal.module__channelList___UWRUMW",
  "fc": "DuplicateGroupConfirmModal.module__channelItem___UWRUMW",
  "R3": "DuplicateGroupConfirmModal.module__avatarWrapper___UWRUMW",
  "E8": "DuplicateGroupConfirmModal.module__channelDetails___UWRUMW",
  "HA": "DuplicateGroupConfirmModal.module__channelName___UWRUMW",
  "Rj": "DuplicateGroupConfirmModal.module__lastActive___UWRUMW",
};

module.exports = exports;
